// Custom hook for easy access to current selection context
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  selectCurrentContext,
  selectSelectedCustomerId,
  selectSelectedSiteId,
  selectSelectedLocationId,
} from '../store/selectors';
import { 
  setSelectedCustomer, 
  setSelectedSite, 
  setSelectedLocation,
  clearAllSelections, 
  setInitialLoad
} from '../store/slices/selectionSlice';

export const useSelection = () => {
  const dispatch = useAppDispatch();
  const context = useAppSelector(selectCurrentContext);
  const customerId = useAppSelector(selectSelectedCustomerId);
  const siteId = useAppSelector(selectSelectedSiteId);
  const locationId = useAppSelector(selectSelectedLocationId);

  return {
    // Current selection objects
    customer: context.customer,
    site: context.site,
    location: context.location,
    
    // Current selection IDs
    customerId,
    siteId,
    locationId,
    
    // Boolean flags
    hasCustomer: context.hasCustomer,
    hasSite: context.hasSite,
    hasLocation: context.hasLocation,
    
    // Actions to change selection
    setCustomer: (id: string | null) => dispatch(setSelectedCustomer(id)),
    setSite: (id: string | null) => dispatch(setSelectedSite(id)),
    setLocation: (id?: string, name?: string) => dispatch(setSelectedLocation({id: id as string, name: name as string})),
    setInitialLoad: (val: boolean | null) => dispatch(setInitialLoad(val)),
    clearAll: () => dispatch(clearAllSelections()),
  };
};

// Usage example:
// const { customer, site, hasCustomer, hasSite, setCustomer } = useSelection();
// if (hasCustomer && hasSite) {
//   // Do something with customer and site
// }